import PropTypes from 'prop-types';
import React, { Fragment, useContext } from 'react';

import {
  TERMS_AND_CONS_LINK,
  PRIVACY_POLICY_LINK,
  COLOSSUS_POLICY_LINK
} from '../../../../constants';

import { SignUpContext } from '../../SignUp';

import Divider from '../../../common/Divider';
import InputField from '../../../widgets/InputField';
import DropdownField from '../../../widgets/DropdownField';
import ExternalLink from '../../../widgets/ExternalLink';

import styles from '../../SignUp.module.scss';

const SignUpFormStep3 = ({
  fields,
}) => {
  const {
    securityQuestions,
    onPropertyChange,
    onInputBlur
  } = useContext(SignUpContext);

  const {
    'security-question': securityQuestion,
    answer,
  } = fields;

  const onQuestionChange = ({ name, value = {} }) => {
    const { name: questionName } = value || {};

    onPropertyChange({
      name,
      value: questionName,
    });
  };

  return (
    <Fragment>
      <DropdownField
        inline
        fullWidth
        label={securityQuestion.label}
        name={securityQuestion.name}
        theme="dark"
        value={securityQuestion.value}
        items={securityQuestions.toJS()}
        className={styles.dropdownField}
        onPropertyChange={onQuestionChange}
        error={securityQuestion.error}
        dataHook={securityQuestion.dataHook}
      />
      <InputField
        label={answer.label}
        name={answer.name}
        dataHook={answer.dataHook}
        type="text"
        value={answer.value}
        onPropertyChange={onPropertyChange}
        className={styles.inputField}
        onInputBlur={onInputBlur}
        error={answer.error}
        inline
      />
      <Divider style={{ marginTop: 107 }} />
      <div className={styles.containerCheckboxes}>
        <div style={{ margin: '16px 0 48px 0' }}>
          <b>By clicking the button below, I confirm:</b>
          <br />
          - I am at least 18 years of age
          <br />
          {'- I understand that any gambling activity on MB Colossus shall be outside the jurisdiction of the AGCC'}
          <br />
          {"- I have read and agreed to Matchbook's"}&nbsp;
          <ExternalLink href={TERMS_AND_CONS_LINK} content="Terms and Conditions" />
          <br />
          <ExternalLink href={PRIVACY_POLICY_LINK} content="Privacy Policy" /> and <ExternalLink href={COLOSSUS_POLICY_LINK} content="MB Colossus Policy" />
        </div>
      </div>
    </Fragment>
  );
};

SignUpFormStep3.propTypes = {
  fields: PropTypes.instanceOf(Object).isRequired,
};

export default SignUpFormStep3;
